import axios from "axios";
import { API } from "./client";

/**
 * Wipe all data for the authenticated user.
 * @param {boolean} wipeOnedrive - Also delete the DD Project Planner OneDrive folder.
 */
export const wipeAccount = async (wipeOnedrive = false) => {
  const res = await axios.post(
    `${API}/account/wipe?wipe_onedrive=${wipeOnedrive}`
  );
  return res.data;
};

/** Preview a destructive reset of the app-owned OneDrive root folder. */
export const previewOneDriveFolderReset = async () => {
  const res = await axios.post(`${API}/account/onedrive-reset/preview`);
  return res.data;
};

/** Delete and recreate the DD Project Planner root while preserving app data. */
export const resetOneDriveFolder = async (confirmationToken) => {
  const res = await axios.post(`${API}/account/onedrive-reset`, {
    confirmation_token: confirmationToken,
  });
  return res.data;
};

/** Fetch the current user's settings. */
export const getAccountSettings = async () => {
  const res = await axios.get(`${API}/account/settings`);
  return res.data;
};

/** Save updated settings. */
export const saveAccountSettings = async (settings) => {
  const res = await axios.patch(`${API}/account/settings`, settings);
  return res.data;
};

/** List all organizations (id + name) — used to populate the org picker. */
export const listOrganizations = async () => {
  const res = await axios.get(`${API}/organizations`);
  return res.data;
};

/**
 * Update the current user's own profile (name + one-time organization pick).
 * @param {{name?: string, organization_id?: string}} data
 */
export const updateProfile = async (data) => {
  const res = await axios.patch(`${API}/account/profile`, data);
  return res.data;
};
